import { render } from "./trash-inner.vue?vue&type=template&id=282c3e17"
import script from "./trash-inner.vue?vue&type=script&lang=ts"
export * from "./trash-inner.vue?vue&type=script&lang=ts"
script.render = render

export default script